import { registerPropertyManagerSection } from '@/core';
import BodyPropertySection from '@/components/editor/property-manager/body/BodyPropertySection.vue';

registerPropertyManagerSection({
  id: 'solid-body',
  title: '实体属性',
  order: 200,
  component: BodyPropertySection,
  isApplicable: (context) => {
    const selected = context.selectedObject as { type?: string } | null;
    return selected?.type === 'body';
  },
});

